module.exports = __webpack_public_path__ + "static/media/delivery_receipts_active.ff4b906c.svg";